import React from "react";
import { Link } from "yarrr";
import { useEnvironment } from "../../../../../Hooks";

import css from "../CompanyMatrix.styl";

/**
 * This is a custom cell renderer for the company logo.
 */
export const CompanyLogoRenderer = ({ data }) => {
	const environment = useEnvironment();
	const domain = environment === "production" ? "https://media.performyard.com" : "https://dev-media.performyard.com";

	return (
		<span style={{ display: "flex", height: "100%", width: "100%", alignItems: "center" }}>
			{data && (
				<img
					alt={`${data.name} Logo`}
					src={`${domain}/company-logo/${data._id}/`}
					style={{
						display: "block",
						width: "25px",
						height: "auto",
						maxHeight: "50%",
						marginRight: "12px",
						filter: "brightness(1.1)",
					}}
				/>
			)}
			<p style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
				<Link className={css.companyLink} href={`/companies/${data._id}/feature-flags`}>
					{data.name}
				</Link>
			</p>
		</span>
	);
};
